module.exports = __webpack_public_path__ + "3640a3885a7302f82e4a4a32d9b1a615.png";